export default async ({
  userId = '',
  password = ''
}, options = {
  showError: true
}) => {
  const [content, error, status] = await POST(URLS.admin.validPassword, {
    userId,
    password
  });
  if (error) return {
    error,
    status
  };
  return content || {};
};